import $ from "jquery";
export default class PrintButton {
    static mount() {
        $(function () {
            new PrintButton();
        });
    }
    constructor() {
        const $buttons = $('.ce-page-buttons-button--print');
        $buttons.on('click', () => {
            window.print();
        });
    }
}
